import classNames from "classnames";
import React, {
    ReactNode,
} from "react";
import Badge from "../badge/Badge";
import Button, { ButtonProps } from "../button/Button";
import Styles from "./FilterList.module.scss";
import useFilterState from "./base";

export interface TableControlsCreateProps<T> extends ButtonProps {
    text?: string;
    count?: number;
    prefixIcon?: ReactNode;
    filterItem: T;
}

const FilterButton = React.forwardRef(<T, >(
    args: TableControlsCreateProps<T>,
    ref: React.ForwardedRef<HTMLButtonElement>,
): ReactNode => {
    const {
        className,
        count,
        variant,
        size,
        prefixIcon,
        text,
        children,
        filterItem,
        ...rest
    } = args;

    const state = useFilterState<T>();
    const [selected, setClicked] = state.useButton();

    const isSelected = selected === filterItem;
    return (
        <Button
            className={classNames(
                Styles.button,
                Styles[`button-${isSelected ? "selected" : "default"}`],
                className,
            )}
            variant={variant ?? (isSelected ? "secondary" : "none")}
            size={size ?? "small"}
            ref={ref}
            prefixIcon={prefixIcon}
            onClick={() => setClicked(filterItem)}
            {...rest}
        >

            {text ?? children}
            {" "}
            {count != null ? <Badge isSelected={isSelected} variant="counter">{count}</Badge> : ""}
        </Button>
    );
});

FilterButton.defaultProps = {

};

export type Type<T> = (
    props: TableControlsCreateProps<T> & { ref?: React.ForwardedRef<HTMLButtonElement> }
) => ReactNode;

export default FilterButton;
